export default __webpack_public_path__ + "static/media/The_Lab_Wht.509fc28d.png";